export const DateBadgeIcons = {
    URGENT: 'urgent',
    SOON: 'soon',
} as const;
export type DateBadgeIcon = (typeof DateBadgeIcons)[keyof typeof DateBadgeIcons];

export const DateBadgeVariants = {
    OUTLINE: 'outline',
    DROP_SHADOW: 'drop_shadow',
} as const;
export type DateBadgeVariant = (typeof DateBadgeVariants)[keyof typeof DateBadgeVariants];

export interface DateBadgeProps {
    date: string;
    icon?: DateBadgeIcon;
    variant?: DateBadgeVariant;
}
